import MessageCard from "../MessageCard";
import MessageHandwriteCard from "../MessageHandwriteCard";
import "./Messages.scoped.scss";
import messagesJson from "./messages.json";
import { BackGroundType } from "../MessageCard/MessageCard";

interface Props {}

// CSVから読み取ったメッセージの一覧をCardとして配置するコンポーネント
export default function Messages(props: Props) {
  return (
    <div className="messages">
      {messagesJson.map((val) =>
        val.backgroundType !== BackGroundType.Handwritten ? (
          <MessageCard
            key={val.twitterID}
            name={val.name}
            twitterID={val.twitterID}
            message={val.message}
            backgroundType={val.backgroundType}
          ></MessageCard>
        ) : (
          <MessageHandwriteCard
            key={val.twitterID}
            name={val.name}
            twitterID={val.twitterID}
            file={val.message}
            option={val.option}
          ></MessageHandwriteCard>
        )
      )}
    </div>
  );
}
